<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 活动 -->
    <div class="activity">
      <div v-html="detail.content"></div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'activity',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
         detail:{}
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/Activity/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.detail = res.data.data
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ActivityDetail.vue